export var wrapper = 'px-4 flex flex-col w-full justify-evenly relative items-center pb-4 bg-infoMain';
export var textWrapper = 'px-4 pt-1.5 flex flex-1 flex-col';
export var button = 'mb-4 mt-4';
export var overlayWrapper = 'overflow-x-hidden overflow-y-auto absolute left-0 right-0 bottom-0 z-50 items-end w-full';
export var iconWrapper = 'pt-6';
export var closeWrapper = 'flex absolute top-1.5 right-0.5 items-center mb-2 pr-1';
export var iconRound = 'rounded-full p-3 bg-infoDark';
export var contentWrapper = 'w-full flex flex-row justify-start items-center py-2';
//# sourceMappingURL=message-modal.styles.js.map